import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import svgEyeOpen from '../../svgs/View_default.svg';
import svgEyeClosed from '../../svgs/View_off_default.svg';
import filter from "../../filter";
import { executeQuery } from "../../requests/executeQuery";
import dollars from "../../dollar-format";
import { addSpaceAfterComma } from '../../utils';
import { BUYERS_LIST, BUYERS_LIST_COUNT } from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_BUYERS } from '../Graphql/Queries/BuyersQuery';
import { fetchData } from '../Service/graphQlService';
import { GET_BUYER_LIST_QUERY, GET_INVESTOR_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { browserHistory } from "react-router";
let cloneDeep = require('lodash.clonedeep');
let find = require('lodash.find');
//thios ui is refrenced by earlier Buyer screen hence used same class names
const limit = 50;
const defaultSubcatNo = 3;

export default class InvestorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
        this.client = null

        this.expandRow = this.expandRow.bind(this);
    }

    componentDidMount() {
        if (this.client) {
            this.fetch(this.props.location.query);
        }
    }
    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else {
            return [];
        }

    }

    parseFilterOptions(query) {
        const filterObject = {};
        if (query) {
            for (const key in query) {
                if (key !== 'order' && key !== 'page') {
                    filterObject[key] = query[key]
                }
            }
        }
        return [filterObject]
    }


    fetch(q) {
        this.setState({ isBusy: true });
        const query = { ...q };
        if (!this.props.isSuper && !query.STATUS) {
            // Legacy values ('1031-Buyer', 'Active') kept so records that were
            // saved before the status rename still show up until migrated.
            query.STATUS = '1031 Buyer,Active Investor,1031-Buyer,Active';
        }
        const options = filter(query, 'buyers');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize: limit
        }
        const token = localStorage.getItem('authToken');
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q);
        if (this.client) {
            fetchData(GET_INVESTOR_LIST_QUERY, { type: "Investor", pageOptions: pageParams, filters: filterOptions, sortOptions: sortOptions })
                .then(res => {
                    const items = res.data.getContacts.data.map((el) => {
                        return { ...el, is_expanded: false };
                    });

                    this.setState({
                        items: items,
                        totalCount: res.data.getContacts.totalCount,
                        error: null,
                        isBusy: null,
                    });
                })
                .catch(err => {
                    this.setState({
                        error: err.message,
                        isBusy: null,
                    });
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    expandRow(el) {
        const items = cloneDeep(this.state.items);
        const item = find(items, { arcimedes_row_id: el.arcimedes_row_id });
        item.is_expanded = !item.is_expanded;
        this.setState({ items });
    }
     handleNavigation(event){
        const value = event.target.value;
        const path = `/${value}s`;
        browserHistory.push(path);
    };
    render() {
        const query = this.props.location.query;
        const columns = [{
            name: 'View',
            textAlign: 'center',
            columnStyle: {
                width: 70
            },
            // render: (el) => {
            //     if (this.props.isSuper)
            //         // return <Link to={{ pathname: `${arc.path.base}buyer/${el.arcimedes_row_id}` }}><Icon svg={svgEdit} /></Link>
            //         return <Link to={{ pathname: `${arc.path.base}investor/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
            //     // return <div className='icon-normal' style={{ cursor: 'pointer' }} onClick={() => this.expandRow(el)}><Icon svg={el.is_expanded ? svgEyeClosed : svgEyeOpen} /></div>
            // },
            render: (el) => {
                const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
                const currentSearch = window.location.search;
                const currentPath = window.location.pathname + currentSearch;
              
                return (
                  <Link to={{
                    pathname: `${basePath}/investor/${el.contact_id}`,
                    state: { fromListUrl: currentPath }
                  }}>
                    <Icon svg={svgEdit} />
                  </Link>
                );
              }
        },];

        if (!this.props.isSuper) {
            columns.push({
                code: 'STRIVE_AGENT_LAST_NAME',
                name: 'Agent',
                render: (el) => el.strive_agent_last_name,
            },)
        }

        columns.push(
            {
                code: 'FIRST_NAME',
                name: 'First Name',
                render: (el) => el.first_name,
            }, {
                code: 'LAST_NAME',
                name: 'Last Name',
                render: (el) => el.last_name,
            },
            {
                code: 'COMPANY_NAME',
                name: 'Company Name',
                render: (el) => el.company_name,
            },
             {
                code: 'COMPANY_ADDRESS',
                name: 'Company Address',
                render: (el) => el.company_address,
            },
            {
                code: 'COMPANY CITY',
                name: 'City',
                render: (el) => el.company_city,
            },
            {
                code: 'COMPANY STATE',
                name: 'State',
                render: (el) => el.company_state,
            },
              {
                code: 'COMPANY ZIP',
                name: 'Zip',
                render: (el) => el.company_zip,
            },
            {
                code: 'PHONE',
                name: 'Phone',
                columnStyle: {
                    minWidth: 132,
                },
                render: (el) => el.phone ?
                    <a href={`tel:${el.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{el.phone}</a> : null,
            },
            {
                code: 'EMAIL',
                name: 'Email',
                render: (el) => el.email ? <a href={`mailto:${el.email}`}>{el.email}</a> : null,
            }, 
            {
            code: 'STATUS',
            name: 'Status',
            render: (el) => el.status,
        },   {
            code: 'CATEGORY',
            name: 'Category',
            render: (el) => el.category ? addSpaceAfterComma(el.category) : '',
        },
            {
                code: 'TYPE',
                name: 'Type',
                render: (el) => el.type ? addSpaceAfterComma(el.type) : '',
            }, {
            code: query.type === 'MT' ? 'multi_tenant_subcategory' : 'single_tenant_subcategory',
            name: 'Subcategory',
            render: (el) => {
                let value = '';
                if (el.type === 'MT' && el.multi_tenant_subcategory)
                    value = addSpaceAfterComma(el.multi_tenant_subcategory);
                if (el.type === 'STNL' && el.single_tenant_subcategory)
                    value = addSpaceAfterComma(el.single_tenant_subcategory);
                if (!el.is_expanded && (value.match(/,/g) || []).length > defaultSubcatNo - 1)
                    return `${value.split(',', defaultSubcatNo).join()}...`;
                return value;
            }
        }, {
            code: 'MARKET',
            name: 'Market',
            render: (el) => el.market ? addSpaceAfterComma(el.market) : '',
        }, {

            code: 'PRICE_MIN',
            name: 'Price Min',
            textAlign: 'right',
            render: (el) => el.price_min ? dollars(el.price_min) : ''
        }, {
            code: 'PRICE_MAX',
            name: 'Price Max',
            textAlign: 'right',
            render: (el) => el.price_max ? dollars(el.price_max) : ''
        },
            {
                code: 'CAP_RATE_MIN',
                name: 'Cap Rate Min',
                textAlign: 'right',
                render: (el) => el.cap_rate_min ? `${el.cap_rate_min}%` : ''
            }, {
            code: 'CAP_RATE_MAX',
            name: 'Cap Rate Max',
            textAlign: 'right',
            render: (el) => el.cap_rate_max ? `${el.cap_rate_max}%` : ''
        }
        , {
            code: 'PROFILE',
            name: 'Profile',
            render: (el) => el.profile,
        }
        );

        if (this.props.isSuper) {
            columns.push({
                code: 'STRIVE_AGENT_LAST_NAME',
                name: 'Agent',
                render: (el) => el.strive_agent_last_name,
            })
        }

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                        // this.fetch(this.props.location.query);
                    }
                    return (
                        <div className='InvestorList' data-is-busy={this.state.isBusy}>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Investors</div>
                                        <LinkComp
                                            to={{
                                                pathname: `${arc.path.base}investor`,
                                                state: { fromListUrl: window.location.pathname + window.location.search }
                                            }}
                                        >
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                        {/* <div style={{ marginLeft: "5px" }}>
                                        <select className="custom-select-investor" onChange={this.handleNavigation} defaultValue="">
                                            <option value="" disabled>Select</option>
                                            <option value="seller">Seller</option>
                                            <option value="buyer">Buyer</option>
                                        </select>
                                    </div> */}
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <SortTable columns={columns}
                                    classNameModifier={this.props.isSuper ? 'buyers-admin' : 'buyers-agent'}
                                    items={this.state.items}
                                    query={query}
                                    hasSubColumns={true}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={this.state.items ? this.state.items.length : false}
                                    limit={limit}
                                    className="buyer"
                                />
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>

        );
    }
}
